module.exports = __webpack_public_path__ + "images/bannerIT-9340b948779ea12633d8ee22fec32621.png";